import React from "react";

const IconYandexSvg = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.17012 3.82979C11.1063 1.65957 14.5956 0.340426 18.2127 0V6C15.8722 6.29787 13.6169 7.19149 11.702 8.6383C9.31905 10.4255 7.53183 12.9362 6.68076 15.7872C5.8297 18.6383 5.87225 21.7021 6.89353 24.5106C7.9148 27.3191 9.78713 29.7447 12.2552 31.4043C14.7233 33.0638 17.702 33.8723 20.6808 33.7447C23.6595 33.617 26.5105 32.5106 28.851 30.6383C31.1488 28.766 32.8084 26.1702 33.5318 23.2766C34.0424 21.2766 34.085 19.1489 33.702 17.1489L38.7659 13.1064V13.0638C40.1276 16.8085 40.3403 20.8936 39.3616 24.766C38.2978 28.8936 35.9574 32.5957 32.6382 35.2766C29.3191 37.9574 25.2339 39.5319 20.9786 39.7447C16.7233 39.9574 12.5105 38.766 8.97863 36.383C5.44672 34 2.76587 30.5532 1.31906 26.5532C-0.127751 22.5532 -0.212863 18.1702 1.02118 14.0851C2.25522 10 4.76587 6.38298 8.17012 3.82979Z"
      fill="#FCCA00"
    />
    <path
      d="M34.936 6.64079V6.68334L31.5743 12.045C30.3403 10.2153 28.7232 8.7259 26.7658 7.66207V19.8323C26.7658 23.577 23.7445 26.5982 19.9998 26.5982C16.2552 26.5982 13.2339 23.577 13.2339 19.8323C13.2339 16.0876 16.2552 13.0663 19.9998 13.0663C21.4041 13.0663 22.6807 13.4919 23.7871 14.2153V0.257812C28.2126 1.10888 32.085 3.40675 34.936 6.64079Z"
      fill="#FC3F1D"
    />
  </svg>
);

export default IconYandexSvg;
